<div class="p-4 " mat-dialog-title>Price Detail(s) as of {{priceDetail.refreshDate  | date:'MM/dd/yy h:mm:ss a'  }}</div>
<mat-dialog-content style="background-color:lightgray;padding-bottom: 20px">
  <div class="pl-5 pr-5  mt-2">
    <mat-card>

      <div *ngIf="priceDetail.market == 'PJM'">

        <div class="row">

          <div class="col-sm-6  col-lg-6">
            <div *ngIf="!editOpportunityName"><h4 class="mb-4"><b>Opportunity Name: </b>
              <span (click)="editOpportunityName = !editOpportunityName">{{priceDetail.opportunityName    }}
                <span  style="color: dodgerblue;font-size: 10px;cursor: pointer">edit</span>
              </span>
            </h4></div>
            <div *ngIf="editOpportunityName">
              <mat-form-field appearance="outline">
                <input matInput [(ngModel)]="opportunityName" name="price"    >
              </mat-form-field>
              <button mat-raised-button   class="ml-5" (click)="updateOpportunityName()" >Update</button>
              <button mat-raised-button   class="ml-5" (click)="editOpportunityName = !editOpportunityName">Cancel</button>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6  col-lg-1"><h3 class="mb-4"><b>Market:</b> PJM</h3></div>
          <div class="col-sm-6  col-lg-1"><h4 class="mb-4"><b>Utility:</b> {{priceDetail.utility}}</h4></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Start Date:</b> {{priceDetail.startDate    }}</h4></div>
          <div class="col-sm-6  col-lg-8"><h4 class="mb-4"><b>Account Numbers:</b> {{priceDetail.accountNumbers }}</h4>
          </div>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th>Month 6</th>
            <th>Month 12</th>
            <th>Month 18</th>
            <th>Month 24</th>
            <th>Month 36</th>
            <th>Month 48</th>
            <th>Month 60</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{formatPjmPrice(priceDetail.month6)}}</td>
            <td>{{formatPjmPrice(priceDetail.month12)}}</td>
            <td>{{formatPjmPrice(priceDetail.month18)}}</td>
            <td>{{formatPjmPrice(priceDetail.month24)}}</td>
            <td>{{formatPjmPrice(priceDetail.month36)}}</td>
            <td>{{formatPjmPrice(priceDetail.month48)}}</td>
            <td>{{formatPjmPrice(priceDetail.month60)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="priceDetail.market == 'ERCOT'">
        <div class="row">

          <div class="col-sm-6  col-lg-6">
            <div *ngIf="!editOpportunityName"><h4 class="mb-4"><b>Opportunity Name: </b>
              <span (click)="editOpportunityName = !editOpportunityName">{{priceDetail.opportunityName    }}
                <span  style="color: dodgerblue;font-size: 10px;cursor: pointer">edit</span>
              </span>
            </h4></div>
            <div *ngIf="editOpportunityName">
              <mat-form-field appearance="outline">
                <input matInput [(ngModel)]="opportunityName" name="price"    >
              </mat-form-field>
              <button mat-raised-button   class="ml-5" (click)="updateOpportunityName()" >Update</button>
              <button mat-raised-button   class="ml-5" (click)="editOpportunityName = !editOpportunityName">Cancel</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6  col-lg-2"><h3 class="mb-4"><b>Market:</b> ERCOT</h3></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Utility:</b> {{priceDetail.utility }}</h4></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Start Date:</b> {{priceDetail.startDate  }}</h4></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Zone:</b> {{priceDetail.zone | titlecase}}</h4></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Load Type:</b> {{priceDetail.loadType }}</h4></div>
          <div class="col-sm-6  col-lg-2"><h4 class="mb-4"><b>Annual kWh:</b> {{priceDetail.kwhYear}}</h4></div>
        </div>

        <table class="table">
          <thead>
          <tr>
            <th colspan="7" class="header1"></th>
            <th colspan="3" class="sweet-header">Sweet Spot Pricing</th>
          </tr>
          <tr>
            <th>Month 6</th>
            <th>Month 12</th>
            <th>Month 18</th>
            <th>Month 24</th>
            <th>Month 36</th>
            <th>Month 48</th>
            <th>Month 60</th>
            <th class="sweet-header">Term</th>
            <th class="sweet-header">Pricing</th>
            <th class="sweet-header">End Month</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{formatErcotPrice(priceDetail.month6)}}</td>
            <td>{{formatErcotPrice(priceDetail.month12)}}</td>
            <td>{{formatErcotPrice(priceDetail.month18)}}</td>
            <td>{{formatErcotPrice(priceDetail.month24)}}</td>
            <td>{{formatErcotPrice(priceDetail.month36)}}</td>
            <td>{{formatErcotPrice(priceDetail.month48)}}</td>
            <td>{{formatErcotPrice(priceDetail.month60)}}</td>
            <td class="sweet-header">{{priceDetail.sweetTerm}}</td>
            <td class="sweet-header">{{formatErcotPrice(priceDetail.sweetPrice)}} </td>
            <td class="sweet-header">{{priceDetail.sweetEndDate}}</td>

          </tr>
          </tbody>
        </table>

      </div>

    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="float-right" *ngIf="priceDetail.market == 'PJM'">
    <button *ngIf="!pjmLoading" mat-raised-button style="background-color: #54B4D3;color: white"
            (click)="calculatePjm()">Refresh
    </button>
    <button *ngIf="pjmLoading" mat-raised-button style="background-color: #54B4D3;color: white">Calculating...</button>
    <button (click)="openContractGenDialog()" type="button" mat-raised-button style="background-color: #54B4D3;color: white" >Download Contract</button>
    <button mat-dialog-close type="button" mat-raised-button style="background-color: #54B4D3;color: white" >Close</button>

  </div>
  <div class="float-right" *ngIf="priceDetail.market == 'ERCOT'">
    <button *ngIf="!ercotLoading" mat-raised-button style="background-color: #54B4D3;color: white"
            (click)="calculateErcot()">Refresh
    </button>
    <button *ngIf="ercotLoading" mat-raised-button style="background-color: #54B4D3;color: white">Calculating...
    </button>
    <button (click)="openContractGenDialog()" type="button" mat-raised-button style="background-color: #54B4D3;color: white" >Download Contract</button>
    <button mat-dialog-close type="button" mat-raised-button style="background-color: #54B4D3;color: white" >Close</button>
  </div>
</mat-dialog-actions>
